module.exports = __webpack_public_path__ + "media/en_us_s4_Robin.e40bd97f.mp3";